import React from 'react'
import ResizeObserver from 'react-resize-observer'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {i18n} from '../../../Utils'
import SVG from '../../Presentational/Atoms/SVG'
import {lighten} from 'polished'
import {CopyToClipboard} from 'react-copy-to-clipboard'

class PasswordsResultContainer extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            height: 0,
        }
    }

    render() {
        const {
            refreshAction,
            passwords,
            backgroundColor,
            onCopy,
        } = this.props

        return (
            <ContainerDiv height={this.state.height}>
                {passwords.length > 0 && <Wrapper backgroundColor={backgroundColor}>
                    <ResizeObserver onResize={rect => this.setState({height: rect.height})}/>
                    <Title>
                        {passwords.length > 1
                            ? i18n('passwords.result.title.plural', {number: passwords.length})
                            : i18n('passwords.result.title')}
                        {/*<Action onClick={refreshAction}>*/}
                            {/*<SVG icon={'refresh'}/>*/}
                        {/*</Action>*/}
                    </Title>
                    {passwords.map(
                        (password, index) => <PasswordResult key={index} backgroundColor={backgroundColor}>
                            <Password>
                                {password}
                            </Password>
                            <CopyAction>
                                <CopyToClipboard text={password} onCopy={onCopy && ((text, result) => onCopy(text, result))}>
                                    <SVG icon={'copy'}/>
                                </CopyToClipboard>
                            </CopyAction>
                        </PasswordResult>)}
                    <PasswordResult backgroundColor={backgroundColor}>
                        <Password/>
                    </PasswordResult>
                </Wrapper>}
            </ContainerDiv>
        )
    }
}

PasswordsResultContainer.propTypes = {
    passwords: PropTypes.array,
    refreshAction: PropTypes.func,
    backgroundColor: PropTypes.string,
    onCopy: PropTypes.func,
}

export default PasswordsResultContainer

const ContainerDiv = styled.div`
    height: ${props => props.height && props.height > 0 ? props.height + 20 : '0'}px;
    transition: height .4s ease;
    overflow: hidden;
`

const Wrapper = styled.div`
    border-radius: 3px;
    transition: background-color .3s ease;
    background-color: ${props => props.backgroundColor ? props.backgroundColor : '#74c974'};
    color: white;
    position: relative;
    overflow: hidden;
    margin: 0 0 20px 0;
    &:before {
        content: "";
        position: absolute;
        left: 0px;
        top: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 2;
        box-shadow: inset 2px 2px 5px 1px rgba(0,0,0,0.2);
        pointer-events: none;
`

const CopyAction = styled.div`
    color: rgba(255,255,255,0.7);
    transition: color .3s ease;
    position: absolute;
    top: 50%;
    right: 5px;
    height: 40px;
    width: 40px;
    cursor: pointer;
    &:hover {
        color: rgba(255,255,255,1);
    }
    .SVGInline {
        svg {
            height: 40px;
            position: absolute;
            transform: translateY(-50%)
        }
    }
`

const PasswordResult = styled.div`
    padding: 8px;
    word-wrap: break-word;
    position: relative;
    transition: background-color .3s ease;
    &:nth-child(odd) {
        background-color: ${props => props.backgroundColor ? lighten(0.1, props.backgroundColor) : '#96CE8B'};
    }

`

const Password = styled.div`
    width: 90%;
    display: inline-block;
    user-select: text;
`

const Title = styled.div`
    position: relative;
    padding: 13px 8px;
    font-weight: 300;
`
const Action = styled.div`
    cursor: pointer;
    position: absolute;
    right: 0;
    top 0;
    color: rgba(255,255,255,0.7);
    transition: color .3s ease;
    height: 48px;
    width: 48px;
    &:hover {
        color: rgba(255,255,255,1);
    }
`



// WEBPACK FOOTER //
// ./src/jsx/Components/Container/Molecules/PasswordsResultContainer.jsx